import styled from "styled-components";

export const VenueBlockFormContainer = styled.div``;
